/**
 * @file コンポーネント：症例サムネイル画像 ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const OperationThumbnailImage = (props) => {
    // Presenterに渡す
    return <Presenter {...props} />;
};
